<template>
    <div class="request-list">
        <Table :columns="tblColumns" :data="tblData" :loading="isLoading" class="request-list__table" />

        <div class="request-list__cards">
            <Spin v-if="isLoading" fix />
            <p v-if="!tblData.length" class="request-list__empty">No data</p>
            <div v-for="row in tblData" :key="row._id" class="request-card">
                <div class="request-card__head">
                    <div>
                        <div class="request-card__dates">{{ row.user && row.user.name }}</div>
                        <div class="request-card__meta">{{ formatDate(row.requestedStart) }}</div>
                        <div class="request-card__meta">
                            Requested {{ formatTimeRange(row.requestedData) }} ·
                            {{ row.requestedHrs ? Number(row.requestedHrs).toFixed(0) + ' hours' : '-' }}
                        </div>
                        <div class="request-card__meta">
                            Initial {{ row.currentData && row.initialHrs ? formatTimeRange(row.currentData) : '-' }} ·
                            {{ row.initialHrs ? Number(row.initialHrs).toFixed(0) + ' hours' : '-' }}
                        </div>
                    </div>
                    <span :class="['request-status', `request-status--${row.status}`]">
                        <span class="request-status__dot" />{{ formatStatus(row.status) }}
                    </span>
                </div>
                <div class="request-card__foot">
                    <span />
                    <div class="request-actions">
                        <Button
                            v-for="btn in actionsFor(row)"
                            :key="btn.content"
                            size="small"
                            :icon="btn.icon"
                            :class="{ 'request-actions__cancel': btn.danger, 'request-actions__approve': btn.success }"
                            @click="btn.onClick"
                        >
                            {{ btn.content }}
                        </Button>
                    </div>
                </div>
            </div>
        </div>

        <Page
            :total="totalCount"
            :current="currentPage"
            :page-size="totalPerPage"
            size="small"
            class="request-list__pagination"
            @on-change="handleOnpageChanged"
        />
        <ViewRequestModal ref="ViewRequest" @create="handleReloadList" />
    </div>
</template>

<script>
import moment from 'moment';
import { formatStatus, renderActions, renderStatus } from '@/components/Requests/Dev/shared/tableRender';
import ViewRequestModal from '@/components/Requests/Dev/TimeDispute/ViewRequestModal';
export default {
    components: { ViewRequestModal },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        requestsDataList: {
            type: Array,
            default: () => [],
        },
        currentPage: {
            type: Number,
            default: 0,
        },
        totalCount: {
            type: Number,
            default: 0,
        },
        totalPerPage: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            tblColumns: [
                {
                    title: 'Date',
                    key: 'createdAt',
                    minWidth: 120,
                    render: (h, params) => {
                        return h(
                            'div',
                            params.row.requestedStart
                                ? moment(params.row.requestedStart).utc().format('YYYY-MM-DD')
                                : ''
                        );
                    },
                },
                {
                    title: 'Employee',
                    key: 'user',
                    minWidth: 180,
                    render: (h, params) => {
                        return h('div', params.row.user.name);
                    },
                },
                {
                    title: 'Initial Time',
                    key: 'initialTime',
                    //fixed: 'left',
                    minWidth: 180,
                    render: (h, params) => {
                        return params.row.currentData && params.row.initialHrs
                            ? h(
                                  'div',
                                  `${moment(params.row.currentData.clockInTime).utc().format('hh:mm A')} - ${moment(
                                      params.row.currentData.clockOutTime
                                  )
                                      .utc()
                                      .format('hh:mm A')}`
                              )
                            : h('div', { class: 'hyphenFont' }, '-');
                    },
                },
                {
                    title: 'Requested Time',
                    key: 'requestedTime',
                    minWidth: 180,
                    render: (h, params) => {
                        return params.row.requestedData
                            ? h(
                                  'div',
                                  `${moment(params.row.requestedData.clockInTime).utc().format('hh:mm A')} - ${moment(
                                      params.row.requestedData.clockOutTime
                                  )
                                      .utc()
                                      .format('hh:mm A')}`
                              )
                            : h('div', { class: 'hyphenFont' }, '-');
                    },
                },
                {
                    title: 'Initial Hours',
                    key: 'initialHrs',
                    minWidth: 120,
                    render: (h, params) => {
                        return params.row.initialHrs
                            ? h('div', Number(params.row.initialHrs).toFixed(0) + ' hours')
                            : h('div', { class: 'hyphenFont' }, '-');
                    },
                },
                {
                    title: 'Requested Hours',
                    key: 'requestedHrs',
                    minWidth: 140,
                    render: (h, params) => {
                        return params.row.requestedHrs
                            ? h('div', Number(params.row.requestedHrs).toFixed(0) + ' hours')
                            : h('div', { class: 'hyphenFont' }, '-');
                    },
                },
                {
                    title: 'Status',
                    key: 'status',
                    minWidth: 120,
                    render: (h, params) => renderStatus(h, params.row.status),
                },
                {
                    title: 'Actions',
                    width: 160,
                    align: 'left',
                    render: (h, params) => renderActions(h, this.actionsFor(params.row)),
                },
            ],
            tblData: [],
        };
    },

    watch: {
        requestsDataList(data) {
            this.tblData = data;
        },
        totalPerPage(total) {
            const arrTotal = [];
            arrTotal.push(total);
        },
    },
    created() {
        if (this.requestsDataList) {
            this.tblData = this.requestsDataList;
        }
    },
    methods: {
        formatStatus,
        formatTimeRange(data) {
            if (!data || !data.clockInTime) return '-';
            return `${moment(data.clockInTime).utc().format('hh:mm A')} - ${moment(data.clockOutTime)
                .utc()
                .format('hh:mm A')}`;
        },
        formatDate(date) {
            return date ? moment(date).utc().format('YYYY-MM-DD') : '-';
        },
        // Same buttons and visibility rules as before, just restyled
        actionsFor(row) {
            const isPending = row.status && row.status.includes('pending');
            return [
                { content: 'View', icon: 'md-eye', onClick: () => this.$refs.ViewRequest.openModal(row, false) },
                ...(isPending
                    ? [
                          {
                              content: 'Approve',
                              icon: 'md-checkmark',
                              success: true,
                              onClick: () => this.handleProcessRequest(row._id, 'approved'),
                          },
                          {
                              content: 'Reject',
                              icon: 'md-close',
                              danger: true,
                              onClick: () => this.handleProcessRequest(row._id, 'rejected'),
                          },
                      ]
                    : []),
            ];
        },
        handleReloadList() {
            this.$emit('reload');
        },
        handleOnpageChanged(page) {
            this.$emit('on-page-change', page);
        },
        handleProcessRequest(id, status) {
            this.$emit('on-process-request', id, status);
        },
    },
};
</script>

<style lang="scss">
ul.pagination.ivu-page {
    text-align: end;
}
.adminRequestsList button {
    width: 25px;
    margin-left: 10px;
}
.adminRequestsList i.ivu-icon {
    margin-left: -12.5px;
}
.btn-hide {
    display: none;
}
.statusLabel {
    display: inline-block;
    color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 5px -1px rgba(0, 0, 0, 0.2);
    vertical-align: middle;
    max-width: 250px;
    padding: 5px;
    text-align: center;
}
.success {
    background: #49e97e;
    font-weight: bold;
}
.warning {
    background: #ffc107;
    font-weight: bold;
}
.danger {
    background: #e9495d;
    font-weight: bold;
}
.primary {
    background: #211841;
}
.secondary {
    background: #828899;
}
</style>

<style lang="scss" scoped>
@import '../Dev/shared/request-table.scss';
</style>
